import { __awaiter } from "tslib";
import { Mutex } from 'async-mutex';
import axios from 'axios';
import CoinFeedbackStatus from './CoinFeedbackSubmissionStatus';
class CoinApiWrapper {
    constructor(config) {
        this.userSweepstakesSummaryMutex = new Mutex();
        this.config = config;
    }
    get authenticated() {
        return !!this.config.token;
    }
    get headers() {
        return this.config.token ? { Authorization: this.config.token } : undefined;
    }
    fetchUspsTracking(trackId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = (yield axios.get(`${this.config.apiDomain}/usps/track/${trackId}`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
        });
    }
    user() {
        return this._user;
    }
    getUser() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this._user) !== null && _a !== void 0 ? _a : (yield this.fetchUser());
        });
    }
    fetchUser() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._user = (_a = (yield axios.get(`${this.config.apiDomain}/user`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return this._user;
        });
    }
    userStatsXyo() {
        return this._userStatsXyo;
    }
    getUserStatsXyo(start, end, sanitize = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (start !== this._userStatsXyoStart || end !== this._userStatsXyoEnd || sanitize !== this._sanitized) {
                this._userStatsXyo = undefined;
            }
            return (_a = this._userStatsXyo) !== null && _a !== void 0 ? _a : (yield this.fetchUserStatsXyo(start, end, sanitize));
        });
    }
    fetchUserStatsXyo(start, end, sanitize = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._userStatsXyo = (_a = (yield axios.get(`${this.config.apiDomain}/user/stats/xyo?start=${start}&end=${end}&sanitize=${sanitize}`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            this._userStatsXyoStart = start;
            this._userStatsXyoEnd = end;
            this._sanitized = sanitize;
            return this._userStatsXyo;
        });
    }
    userSanitized() {
        return this._userUnsanitized;
    }
    getUserSanitized() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this._userUnsanitized) !== null && _a !== void 0 ? _a : (yield this.fetchUserSanitized());
        });
    }
    fetchUserSanitized() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._userUnsanitized = (_a = (yield axios.get(`${this.config.apiDomain}/user?sanitize=true`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return this._userUnsanitized;
        });
    }
    sweepstakes() {
        return this._sweepstakes;
    }
    getSweepstakes() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this._sweepstakes) !== null && _a !== void 0 ? _a : (yield this.fetchSweepstakes());
        });
    }
    fetchSweepstakes() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._sweepstakes = (_a = (yield axios.get(`${this.config.apiDomain}/sweepstakes`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return this._sweepstakes;
        });
    }
    userSweepstakesStats() {
        return this._userSweepstakesSummary;
    }
    getUserSweepstakesSummary() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.userSweepstakesSummaryMutex.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                return (_a = this._userSweepstakesSummary) !== null && _a !== void 0 ? _a : (yield this.fetchUserSweepstakesSummary());
            }));
        });
    }
    fetchUserSweepstakesSummary() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._userSweepstakesSummary = (_a = (yield axios.get(`${this.config.apiDomain}/user/sweepstakes/summary`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return this._userSweepstakesSummary;
        });
    }
    userSweepstakes() {
        return this._userSweepstakes;
    }
    getUserSweepstakes() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this._userSweepstakes) !== null && _a !== void 0 ? _a : (yield this.fetchUserSweepstakes());
        });
    }
    fetchUserSweepstakes() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this._userSweepstakes = (_a = (yield axios.get(`${this.config.apiDomain}/user/sweepstakes`, {
                headers: this.headers,
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return this._userSweepstakes;
        });
    }
    paidEntry(transactionId, optionsId, entries, email, source) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield axios.post(`${this.config.apiDomain}/sweepstakes/paid-entry`, {
                email,
                entries,
                optionsId,
                source,
                transactionId,
            });
        });
    }
    trackEvents(events) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/t/event`, events, {
                headers: this.headers,
            })).data;
        });
    }
    submitFeedback(feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/feedback`, feedback, {
                headers: this.headers,
            })).data;
        });
    }
    updateFeedbackStatus(feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/feedback/status`, feedback, {
                headers: this.headers,
            })).data;
        });
    }
    fetchFeedback(status = CoinFeedbackStatus.All) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`${this.config.apiDomain}/feedback?status=${status}`, {
                headers: this.headers,
            })).data;
        });
    }
    createOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/rebilly/orders`, params)).data;
        });
    }
    createInvoice(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/rebilly/invoices`, params)).data;
        });
    }
    createTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/rebilly/transactions`, params)).data;
        });
    }
    createCustomer(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.config.apiDomain}/rebilly/customers`, params)).data;
        });
    }
    static get(config) {
        return new CoinApiWrapper(config);
    }
}
export default CoinApiWrapper;
//# sourceMappingURL=Wrapper.js.map